import httpClient from "../../../../../shared/api/httpClient";
import { qs } from "../../../../../shared/api/qs";
import {
  downloadBlob,
  getFilenameFromContentDisposition,
} from "../../../../../shared/utils/downloadBlob";

function requirePurchaseId(purchaseId) {
  if (!purchaseId) throw new Error("El ID de la compra es requerido");
}

export function getPurchases({
  page = 1,
  limit = 20,
  supplierId,
  status,
  dateFrom,
  dateTo,
  signal,
} = {}) {
  const query = qs({ page, limit, supplierId, status, dateFrom, dateTo });
  return httpClient.get(`/stock/purchases${query}`, { signal });
}

export function createPurchaseOrder(data) {
  return httpClient.post("/stock/purchase-orders", data);
}

export function getPurchase(purchaseId, { signal } = {}) {
  requirePurchaseId(purchaseId);
  return httpClient.get(`/stock/purchases/${purchaseId}`, { signal });
}

export function updatePurchase(purchaseId, data) {
  requirePurchaseId(purchaseId);
  return httpClient.patch(`/stock/purchases/${purchaseId}`, data);
}

export function approvePurchase(purchaseId) {
  requirePurchaseId(purchaseId);
  return httpClient.post(`/stock/purchases/${purchaseId}/approve`);
}

export function deletePurchase(purchaseId) {
  requirePurchaseId(purchaseId);
  return httpClient.delete(`/stock/purchases/${purchaseId}`);
}

export function getPurchaseSuppliers({
  page = 1,
  limit = 100,
  search,
  signal,
} = {}) {
  const query = qs({ page, limit, search, isActive: true });
  return httpClient.get(`/stock/suppliers${query}`, { signal });
}

export function getSupplierPurchaseItems(
  supplierId,
  { search, categoryId, signal } = {}
) {
  if (!supplierId) throw new Error("El ID del proveedor es requerido");
  const query = qs({ search, categoryId });
  return httpClient.get(
    `/stock/purchase-items/supplier/${supplierId}${query}`,
    { signal }
  );
}

export function getPurchaseCategoryOptions({ signal } = {}) {
  return httpClient.get("/stock/ingredient-categories/options", { signal });
}

export async function downloadPurchasePdf(purchaseId) {
  requirePurchaseId(purchaseId);
  const response = await httpClient.getBlobWithHeaders(
    `/stock/purchases/${purchaseId}/pdf`,
    { headers: { Accept: "application/pdf" } }
  );
  const fileName =
    getFilenameFromContentDisposition(
      response.headers?.get?.("content-disposition")
    ) || "lista-de-compra.pdf";

  downloadBlob(response.data, fileName);
  return { fileName };
}
